/**
 * Team Block - Modal functionality
 * Opens a modal with person description when their image is clicked
 * Scoped per block to support multiple team blocks on the same page
 */
(function() {
    'use strict';

    function initTeamBlock() {
        const teamBlocks = document.querySelectorAll('.team');

        teamBlocks.forEach(function(block) {
            const modal = block.querySelector('.team-modal');
            if (!modal) return;

            const triggerButtons = block.querySelectorAll('[data-modal-trigger]');
            const closeButtons = block.querySelectorAll('[data-modal-close]');
            const modalPersons = modal.querySelectorAll('.team-modal-person');
            let lastFocusedElement = null;

            // Open modal
            function openModal(personId) {
                const targetPerson = modal.querySelector('[data-person-modal="' + personId + '"]');
                if (!targetPerson) return;

                // Hide all modal persons
                modalPersons.forEach(person => person.hidden = true);

                // Show target person
                targetPerson.hidden = false;

                // Show modal
                modal.hidden = false;
                document.body.style.overflow = 'hidden';

                // Focus close button
                const closeButton = modal.querySelector('.team-modal-close');
                if (closeButton) {
                    closeButton.focus();
                }
            }

            // Close modal
            function closeModal() {
                modal.hidden = true;
                document.body.style.overflow = '';

                // Return focus to trigger button
                if (lastFocusedElement) {
                    lastFocusedElement.focus();
                    lastFocusedElement = null;
                }
            }

            // Add click listeners to trigger buttons
            triggerButtons.forEach(function(button) {
                if (button.disabled) return;

                button.addEventListener('click', function() {
                    lastFocusedElement = this;
                    const personId = this.getAttribute('data-modal-trigger');
                    openModal(personId);
                });
            });

            // Add click listeners to close buttons
            closeButtons.forEach(function(button) {
                button.addEventListener('click', closeModal);
            });

            // Close on Escape key
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && !modal.hidden) {
                    closeModal();
                }
            });

            // Trap focus inside modal
            modal.addEventListener('keydown', function(e) {
                if (e.key === 'Tab') {
                    const focusableElements = modal.querySelectorAll(
                        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                    );
                    const firstElement = focusableElements[0];
                    const lastElement = focusableElements[focusableElements.length - 1];

                    if (e.shiftKey && document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                    } else if (!e.shiftKey && document.activeElement === lastElement) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            });
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTeamBlock);
    } else {
        initTeamBlock();
    }
})();
